module.exports = __webpack_public_path__ + "img/kaikei.796b2048.png";